import { BaseComponent } from '../base-component.js';
import { getIcon } from '../../shared/icons.js';

export class AgIcon extends BaseComponent {
  static get observedAttributes() {
    return ['name', 'size'];
  }

  protected styles(): string {
    return '';
  }

  protected template(): string {
    return `<span class="ag-icon"><slot></slot></span>`;
  }

  protected async afterRender(): Promise<void> {
    const name = this.getAttribute('name');
    if (name) {
      const iconSpan = this.$('.ag-icon');
      if (iconSpan) {
        const svgContent = await getIcon(name);
        iconSpan.innerHTML = svgContent;
      }
    }
  }

  attributeChangedCallback(name: string, oldValue: string, newValue: string) {
    if (oldValue !== newValue && name === 'name') {
      this.render();
      this.afterRender();
    }
  }
}

customElements.define('ag-icon', AgIcon);
